(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fe-google-trust"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fotoema-google-trust')) {
    customElements.define('fotoema-google-trust', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.eventController = new AbortController();
        this.track = this.querySelector('.fe-google-trust__track');
        this.controls = this.querySelector('.fe-google-trust__controls');
        this.buttons = [...this.querySelectorAll('[data-direction]')];
        if (!this.track || !this.controls) return;
        this.updateControls = () => {
          const remaining = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = remaining < 3;
          this.buttons[0].disabled = this.track.scrollLeft < 3;
          this.buttons[1].disabled = this.track.scrollLeft > remaining - 3;
        };
        this.buttons.forEach(button => {
          button.addEventListener('click', () => {
            const card = this.track.querySelector('.fe-google-trust__card');
            const distance = card ? card.getBoundingClientRect().width + 16 : this.track.clientWidth;
            this.track.scrollBy({left: Number(button.dataset.direction) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          }, {signal: this.eventController.signal});
        });
        this.track.addEventListener('scroll', this.updateControls, {passive: true, signal: this.eventController.signal});
        this.resizeObserver = new ResizeObserver(this.updateControls);
        this.resizeObserver.observe(this.track);
        this.updateControls();
      }
      disconnectedCallback() {
        if (this.eventController) this.eventController.abort();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.track && this.updateControls) this.track.removeEventListener('scroll', this.updateControls);
        this.initialized = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fe-tradein-multi"] && !Shopify.designMode) return;
  try {
    
(() => {
  const STORAGE_KEY = 'fe_tradein_quote_v1';
  const QUOTE_DAYS = 7;
  const conditionInfo = {
    a:{title:'A — Pari al nuovo',text:'Nessun segno evidente di utilizzo. Estetica praticamente perfetta e funzionamento completo.'},
    b:{title:'B — Ottime condizioni',text:'Lievi segni di normale utilizzo, difficilmente visibili. Perfettamente funzionante.'},
    c:{title:'C — Buone condizioni',text:'Normali segni di utilizzo e possibili piccoli segni estetici. Perfettamente funzionante.'},
    d:{title:'D — Usato',text:'Segni di utilizzo evidenti, graffi o usura estetica. Perfettamente funzionante.'},
    e:{title:'E — Molto usato',text:'Usura importante e segni evidenti, ma prodotto ancora perfettamente funzionante.'}
  };
  const money = new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',maximumFractionDigits:0});
  const dateFmt = new Intl.DateTimeFormat('it-IT',{day:'2-digit',month:'2-digit',year:'numeric'});
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const compact = value => normalize(value).replace(/[^a-z0-9]/g,'');
  const parseAccessories = raw => String(raw || '').split(/\r?\n/).map(v=>v.trim()).filter(Boolean).map(line=>{
    const parts=line.split('|');
    return {label:(parts[0]||'').trim(),deduction:Number(parts[1]||0)||0};
  });
  const uid = prefix => prefix + '-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2,8);
  const isoPlusDays = (iso,days) => {
    const date = iso ? new Date(iso) : new Date();
    date.setDate(date.getDate()+days);
    return date.toISOString();
  };
  const quoteId = () => {
    const d=new Date();
    const yy=String(d.getFullYear()).slice(-2);
    const mm=String(d.getMonth()+1).padStart(2,'0');
    const dd=String(d.getDate()).padStart(2,'0');
    const code=Math.random().toString(36).slice(2,7).toUpperCase();
    return 'FE-PM-' + yy + mm + dd + '-' + code;
  };

  function init(root){
    if(root.dataset.ready==='true') return;
    root.dataset.ready='true';

    const dataNode=root.querySelector('[data-products]');
    const search=root.querySelector('[data-search]');
    const results=root.querySelector('[data-results]');
    const selected=root.querySelector('[data-selected]');
    const conditionStep=root.querySelector('[data-condition-step]');
    const accessoryStep=root.querySelector('[data-accessory-step]');
    const conditions=root.querySelector('[data-conditions]');
    const accessories=root.querySelector('[data-accessories]');
    const estimate=root.querySelector('[data-estimate]');
    const estimatePrice=root.querySelector('[data-estimate-price]');
    const estimateMeta=root.querySelector('[data-estimate-meta]');
    const addLineButton=root.querySelector('[data-add-line]');
    const editingBanner=root.querySelector('[data-editing-banner]');
    const cancelEdit=root.querySelector('[data-cancel-edit]');
    const expiredBanner=root.querySelector('[data-expired]');
    const refreshQuoteButton=root.querySelector('[data-refresh-quote]');
    const sticky=root.querySelector('[data-sticky]');
    const stickyCount=root.querySelector('[data-sticky-count]');
    const stickyTotal=root.querySelector('[data-sticky-total]');
    const openCart=root.querySelector('[data-open-cart]');
    const cartDialog=root.querySelector('[data-cart-dialog]');
    const closeCart=root.querySelector('[data-close-cart]');
    const drawerId=root.querySelector('[data-drawer-id]');
    const drawerEmpty=root.querySelector('[data-drawer-empty]');
    const cartLines=root.querySelector('[data-cart-lines]');
    const drawerFoot=root.querySelector('[data-drawer-foot]');
    const drawerTotal=root.querySelector('[data-drawer-total]');
    const addAnother=root.querySelector('[data-add-another]');
    const openSummary=root.querySelector('[data-open-summary]');
    const clearQuote=root.querySelector('[data-clear-quote]');
    const summaryDialog=root.querySelector('[data-summary-dialog]');
    const closeSummary=root.querySelector('[data-close-summary]');
    const summaryId=root.querySelector('[data-summary-id]');
    const summaryCreated=root.querySelector('[data-summary-created]');
    const summaryExpiry=root.querySelector('[data-summary-expiry]');
    const summaryLines=root.querySelector('[data-summary-lines]');
    const summaryTotal=root.querySelector('[data-summary-total]');
    const backToEdit=root.querySelector('[data-back-to-edit]');
    const saveServerButton=root.querySelector('[data-save-server]');
    const saveStatus=root.querySelector('[data-save-status]');
    const printQuoteButton=root.querySelector('[data-print-quote]');
    const saveUrl=(root.dataset.saveUrl||'').trim();
    const customerId=(root.dataset.customerId||'').trim();
    const authTimestamp=(root.dataset.authTimestamp||'').trim();
    const authSignature=(root.dataset.authSignature||'').trim();
    const accountLoginUrl=(root.dataset.accountLoginUrl||'/account/login').trim();
    const customerName=(root.dataset.customerName||'').trim();
    const customerEmail=(root.dataset.customerEmail||'').trim();
    const shopName=(root.dataset.shopName||'FotoEMA').trim();
    const toast=root.querySelector('[data-toast]');

    let products=[];
    try{products=JSON.parse(dataNode.textContent||'[]').filter(p=>String(p.active)!=='false');}catch(error){products=[];}

    let currentProduct=null;
    let currentCondition=null;
    let currentAccessories=[];
    let editingLineId=null;
    let toastTimer=null;

    const blankQuote=()=>({version:1,quoteId:null,createdAt:null,expiresAt:null,serverSaveRequestedAt:null,items:[]});
    let quote=blankQuote();

    try{
      const stored=JSON.parse(localStorage.getItem(STORAGE_KEY)||'null');
      if(stored && Array.isArray(stored.items)) quote=stored;
    }catch(error){
      quote=blankQuote();
    }

    const isExpired=()=>Boolean(quote.expiresAt && Date.now()>new Date(quote.expiresAt).getTime());
    const total=()=>quote.items.reduce((sum,line)=>sum+Number(line.estimatedValue||0),0);
    const productByHandle=handle=>products.find(p=>p.handle===handle);
    const productByIdentity=line=>productByHandle(line.productHandle) || products.find(p=>p.mpn && line.mpn && p.mpn===line.mpn) || products.find(p=>p.brand===line.brand && p.model===line.model);

    const saveQuote=()=>{
      if(quote.items.length){
        localStorage.setItem(STORAGE_KEY,JSON.stringify(quote));
      }else{
        localStorage.removeItem(STORAGE_KEY);
      }
    };

    const showToast=message=>{
      toast.textContent=message;
      toast.hidden=false;
      clearTimeout(toastTimer);
      toastTimer=setTimeout(()=>{toast.hidden=true;},2200);
    };

    const ensureQuoteIdentity=()=>{
      if(!quote.quoteId){
        const now=new Date().toISOString();
        quote.quoteId=quoteId();
        quote.createdAt=now;
        quote.expiresAt=isoPlusDays(now,QUOTE_DAYS);
      }
    };

    const recalcLine=(line,product)=>{
      if(!product) return line;
      const defs=parseAccessories(product.accessories);
      const existing=new Map((line.accessories||[]).map(item=>[item.label,item]));
      const nextAccessories=defs.map(def=>{
        const old=existing.get(def.label);
        return {label:def.label,present:old ? Boolean(old.present) : true,deduction:def.deduction};
      });
      const base=Number(product.prices?.[line.condition]||0);
      const deduction=nextAccessories.reduce((sum,item)=>sum+(item.present?0:Number(item.deduction||0)),0);
      return Object.assign({},line,{
        brand:product.brand,
        model:product.model,
        mpn:product.mpn,
        baseValue:base,
        accessories:nextAccessories,
        estimatedValue:Math.max(0,base-deduction),
        stale:false,
        updatedAt:new Date().toISOString()
      });
    };

    const refreshAllPrices=()=>{
      quote.items=quote.items.map(line=>{
        const product=productByIdentity(line);
        if(!product) return Object.assign({},line,{stale:true});
        return recalcLine(line,product);
      });
      if(quote.items.length){
        quote.serverSaveRequestedAt=null;
        const now=new Date().toISOString();
        quote.createdAt=now;
        quote.expiresAt=isoPlusDays(now,QUOTE_DAYS);
        if(!quote.quoteId) quote.quoteId=quoteId();
      }
      saveQuote();
      renderCart();
      showToast('Valutazioni aggiornate');
    };

    const renderExpired=()=>{
      expiredBanner.hidden=!isExpired() || !quote.items.length;
    };

    const renderCart=()=>{
      const count=quote.items.length;
      const grandTotal=total();
      sticky.hidden=count===0;
      stickyCount.textContent=count + (count===1?' prodotto':' prodotti');
      stickyTotal.textContent=money.format(grandTotal);
      drawerId.textContent=quote.quoteId||'—';
      drawerTotal.textContent=money.format(grandTotal);
      drawerEmpty.hidden=count>0;
      drawerFoot.hidden=count===0;
      cartLines.innerHTML='';

      quote.items.forEach(line=>{
        const row=document.createElement('div');
        row.className='fe-tradein-multi__line';

        const top=document.createElement('div');
        top.className='fe-tradein-multi__line-top';

        const info=document.createElement('div');
        const title=document.createElement('div');
        title.className='fe-tradein-multi__line-title';
        title.textContent=line.brand+' '+line.model;
        const sub=document.createElement('div');
        sub.className='fe-tradein-multi__line-sub';
        sub.textContent=(conditionInfo[line.condition]?.title||line.condition)+(line.stale?' · Prezzo da verificare':'');
        info.append(title,sub);

        const value=document.createElement('div');
        value.className='fe-tradein-multi__line-value';
        value.textContent=money.format(Number(line.estimatedValue||0));
        top.append(info,value);

        const accessoryText=document.createElement('div');
        accessoryText.className='fe-tradein-multi__line-accessories';
        const present=(line.accessories||[]).filter(x=>x.present).map(x=>x.label);
        const missing=(line.accessories||[]).filter(x=>!x.present).map(x=>x.label);
        accessoryText.textContent=(present.length?'Presenti: '+present.join(', '):'Nessun accessorio selezionato')+(missing.length?' · Mancanti: '+missing.join(', '):'');

        const actions=document.createElement('div');
        actions.className='fe-tradein-multi__line-actions';
        const edit=document.createElement('button');
        edit.type='button';
        edit.textContent='Modifica';
        edit.addEventListener('click',()=>startEdit(line.lineId));
        const remove=document.createElement('button');
        remove.type='button';
        remove.textContent='Rimuovi';
        remove.addEventListener('click',()=>removeLine(line.lineId));
        actions.append(edit,remove);

        row.append(top,accessoryText,actions);
        cartLines.appendChild(row);
      });

      renderExpired();
    };

    const renderSummary=()=>{
      summaryId.textContent=quote.quoteId||'—';
      summaryCreated.textContent=quote.createdAt?'Creata il '+dateFmt.format(new Date(quote.createdAt)):'';
      summaryExpiry.textContent=quote.expiresAt?'Valori indicativi fino al '+dateFmt.format(new Date(quote.expiresAt)):'';
      summaryLines.innerHTML='';
      quote.items.forEach(line=>{
        const row=document.createElement('div');
        row.className='fe-tradein-multi__summary-line';
        const info=document.createElement('div');
        const title=document.createElement('strong');
        title.textContent=line.brand+' '+line.model;
        const sub=document.createElement('small');
        sub.textContent=conditionInfo[line.condition]?.title||line.condition;
        info.append(title,sub);
        const value=document.createElement('b');
        value.textContent=money.format(Number(line.estimatedValue||0));
        row.append(info,value);
        summaryLines.appendChild(row);
      });
      summaryTotal.textContent=money.format(total());

      if(!customerId){
        saveServerButton.textContent='Accedi per salvare';
      }else if(quote.serverSaveRequestedAt){
        saveServerButton.textContent='Aggiorna preventivo salvato';
      }else{
        saveServerButton.textContent='Salva valutazione nel mio account';
      }

      if(quote.serverSaveRequestedAt){
        saveStatus.hidden=false;
        saveStatus.textContent='Ultima richiesta di salvataggio: '+dateFmt.format(new Date(quote.serverSaveRequestedAt))+' · '+quote.quoteId;
      }else{
        saveStatus.hidden=true;
        saveStatus.textContent='';
      }
    };

    const findProducts=query=>{
      const needle=normalize(query);
      const needleCompact=compact(query);
      if(needle.length<2) return [];
      return products.filter(product=>{
        const haystack=[product.brand,product.model,product.mpn,product.aliases].filter(Boolean).join(' ');
        return normalize(haystack).includes(needle)||compact(haystack).includes(needleCompact);
      }).slice(0,8);
    };

    const hideResults=()=>{
      results.hidden=true;
      results.innerHTML='';
    };

    const renderResults=matches=>{
      results.innerHTML='';
      if(!matches.length){
        const empty=document.createElement('div');
        empty.className='fe-tradein-multi__empty';
        empty.textContent='Nessun modello trovato nel test.';
        results.appendChild(empty);
      }else{
        matches.forEach(product=>{
          const button=document.createElement('button');
          button.type='button';
          button.className='fe-tradein-multi__result';

          const text=document.createElement('span');
          const title=document.createElement('strong');
          title.textContent=product.brand+' '+product.model;
          const mpn=document.createElement('span');
          mpn.textContent=product.mpn||'';
          text.append(title,mpn);

          const arrow=document.createElement('b');
          arrow.setAttribute('aria-hidden','true');
          arrow.textContent='›';

          button.append(text,arrow);
          button.addEventListener('click',()=>selectProduct(product));
          results.appendChild(button);
        });
      }
      results.hidden=false;
    };

    const setCondition=key=>{
      currentCondition=key;
      [...conditions.querySelectorAll('.fe-tradein-multi__condition')].forEach(label=>{
        const input=label.querySelector('input');
        const active=input.value===key;
        input.checked=active;
        label.classList.toggle('is-selected',active);
      });
      updateEstimate();
    };

    const renderConditions=()=>{
      conditions.innerHTML='';
      Object.entries(conditionInfo).forEach(([key,info])=>{
        const label=document.createElement('label');
        label.className='fe-tradein-multi__condition';
        const input=document.createElement('input');
        input.type='radio';
        input.name='fe-multi-condition-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,5);
        input.value=key;
        const text=document.createElement('span');
        const strong=document.createElement('strong');
        strong.textContent=info.title;
        const small=document.createElement('small');
        small.textContent=info.text;
        text.append(strong,small);
        input.addEventListener('change',()=>setCondition(key));
        label.append(input,text);
        conditions.appendChild(label);
      });
      const radios=[...conditions.querySelectorAll('input[type="radio"]')];
      const group='fe-multi-condition-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,6);
      radios.forEach(radio=>{radio.name=group;});
    };

    const renderAccessories=(saved)=>{
      accessories.innerHTML='';
      currentAccessories=parseAccessories(currentProduct?.accessories);
      const savedMap=new Map((saved||[]).map(item=>[item.label,item]));
      currentAccessories.forEach((item,index)=>{
        const old=savedMap.get(item.label);
        const label=document.createElement('label');
        label.className='fe-tradein-multi__accessory';
        const checkbox=document.createElement('input');
        checkbox.type='checkbox';
        checkbox.checked=old ? Boolean(old.present) : true;
        checkbox.dataset.index=String(index);
        label.classList.toggle('is-present',checkbox.checked);
        const text=document.createElement('span');
        text.textContent=item.label;
        checkbox.addEventListener('change',()=>{
          label.classList.toggle('is-present',checkbox.checked);
          updateEstimate();
        });
        label.append(checkbox,text);
        accessories.appendChild(label);
      });
    };

    const getAccessoryState=()=>{
      return [...accessories.querySelectorAll('input[type="checkbox"]')].map(checkbox=>{
        const item=currentAccessories[Number(checkbox.dataset.index)];
        return {label:item.label,present:checkbox.checked,deduction:Number(item.deduction||0)};
      });
    };

    const currentEstimate=()=>{
      if(!currentProduct||!currentCondition) return 0;
      const base=Number(currentProduct.prices?.[currentCondition]||0);
      const deduction=getAccessoryState().reduce((sum,item)=>sum+(item.present?0:item.deduction),0);
      return Math.max(0,base-deduction);
    };

    const updateEstimate=()=>{
      if(!currentProduct||!currentCondition){
        estimate.hidden=true;
        return;
      }
      estimatePrice.textContent=money.format(currentEstimate());
      estimateMeta.textContent=currentProduct.brand+' '+currentProduct.model+' · '+conditionInfo[currentCondition].title;
      addLineButton.textContent=editingLineId?'Aggiorna prodotto':'Aggiungi alla mia valutazione';
      estimate.hidden=false;
    };

    const selectProduct=(product,savedLine)=>{
      currentProduct=product;
      currentCondition=null;
      search.value=product.brand+' '+product.model;
      selected.textContent=product.brand+' '+product.model+(product.mpn?' · '+product.mpn:'');
      selected.hidden=false;
      hideResults();
      renderConditions();
      renderAccessories(savedLine?.accessories||[]);
      conditionStep.hidden=false;
      accessoryStep.hidden=false;
      estimate.hidden=true;
      if(savedLine?.condition) setCondition(savedLine.condition);
      conditionStep.scrollIntoView({behavior:'smooth',block:'nearest'});
    };

    const resetBuilder=()=>{
      currentProduct=null;
      currentCondition=null;
      currentAccessories=[];
      editingLineId=null;
      search.value='';
      selected.hidden=true;
      selected.textContent='';
      conditionStep.hidden=true;
      accessoryStep.hidden=true;
      estimate.hidden=true;
      conditions.innerHTML='';
      accessories.innerHTML='';
      editingBanner.hidden=true;
      hideResults();
      addLineButton.textContent='Aggiungi alla mia valutazione';
    };

    const addOrUpdateLine=()=>{
      if(!currentProduct||!currentCondition) return;
      if(isExpired() && quote.items.length) refreshAllPrices();
      ensureQuoteIdentity();

      const state=getAccessoryState();
      const base=Number(currentProduct.prices?.[currentCondition]||0);
      const line={
        lineId:editingLineId||uid('line'),
        productHandle:currentProduct.handle,
        brand:currentProduct.brand,
        model:currentProduct.model,
        mpn:currentProduct.mpn,
        condition:currentCondition,
        baseValue:base,
        accessories:state,
        estimatedValue:currentEstimate(),
        addedAt:new Date().toISOString(),
        updatedAt:new Date().toISOString(),
        stale:false
      };

      quote.serverSaveRequestedAt=null;

      if(editingLineId){
        const index=quote.items.findIndex(item=>item.lineId===editingLineId);
        if(index>=0){
          line.addedAt=quote.items[index].addedAt||line.addedAt;
          quote.items[index]=line;
        }
        showToast('Prodotto aggiornato');
      }else{
        quote.items.push(line);
        showToast('Prodotto aggiunto alla valutazione');
      }

      saveQuote();
      renderCart();
      resetBuilder();
      search.scrollIntoView({behavior:'smooth',block:'center'});
    };

    const startEdit=lineId=>{
      const line=quote.items.find(item=>item.lineId===lineId);
      if(!line) return;
      const product=productByIdentity(line);
      if(!product){
        showToast('Questo modello non è più disponibile nel listino');
        return;
      }
      editingLineId=lineId;
      editingBanner.hidden=false;
      cartDialog.close();
      selectProduct(product,line);
      addLineButton.textContent='Aggiorna prodotto';
      root.querySelector('[data-builder]').scrollIntoView({behavior:'smooth',block:'start'});
    };

    const removeLine=lineId=>{
      quote.serverSaveRequestedAt=null;
      quote.items=quote.items.filter(item=>item.lineId!==lineId);
      if(!quote.items.length) quote=blankQuote();
      saveQuote();
      renderCart();
      if(!quote.items.length && cartDialog.open) cartDialog.close();
      showToast('Prodotto rimosso');
    };

    const clearAll=()=>{
      quote=blankQuote();
      saveQuote();
      renderCart();
      resetBuilder();
      if(cartDialog.open) cartDialog.close();
      showToast('Valutazione svuotata');
    };

    search.addEventListener('input',()=>renderResults(findProducts(search.value)));
    search.addEventListener('focus',()=>{if(search.value.trim().length>=2) renderResults(findProducts(search.value));});
    document.addEventListener('click',event=>{
      const wrap=root.querySelector('.fe-tradein-multi__search-wrap');
      if(wrap && !wrap.contains(event.target)) hideResults();
    });

    addLineButton.addEventListener('click',addOrUpdateLine);
    cancelEdit.addEventListener('click',resetBuilder);
    refreshQuoteButton.addEventListener('click',refreshAllPrices);

    openCart.addEventListener('click',()=>cartDialog.showModal());
    closeCart.addEventListener('click',()=>cartDialog.close());
    cartDialog.addEventListener('click',event=>{if(event.target===cartDialog) cartDialog.close();});

    addAnother.addEventListener('click',()=>{
      cartDialog.close();
      resetBuilder();
      search.scrollIntoView({behavior:'smooth',block:'center'});
      setTimeout(()=>search.focus(),350);
    });

    openSummary.addEventListener('click',()=>{
      renderSummary();
      cartDialog.close();
      summaryDialog.showModal();
    });
    closeSummary.addEventListener('click',()=>summaryDialog.close());
    summaryDialog.addEventListener('click',event=>{if(event.target===summaryDialog) summaryDialog.close();});
    backToEdit.addEventListener('click',()=>{
      summaryDialog.close();
      cartDialog.showModal();
    });

    const escapeHtml=value=>String(value??'')
      .replaceAll('&','&amp;')
      .replaceAll('<','&lt;')
      .replaceAll('>','&gt;')
      .replaceAll('"','&quot;')
      .replaceAll("'","&#039;");

    const buildPrintDocument=()=>{
      ensureQuoteIdentity();

      const rows=quote.items.map((line,index)=>{
        const present=(line.accessories||[]).filter(item=>item.present).map(item=>item.label);
        const missing=(line.accessories||[]).filter(item=>!item.present).map(item=>item.label);
        const missingText=missing.length
          ? missing.map(escapeHtml).join(', ')
          : 'Nessuno';
        const presentText=present.length
          ? present.map(escapeHtml).join(', ')
          : 'Nessuno';
        const condition=conditionInfo[line.condition]?.title||line.condition;

        return `
          <article class="product">
            <div class="product__top">
              <div class="product__index">${index+1}</div>
              <div class="product__main">
                <h2>${escapeHtml(line.brand)} ${escapeHtml(line.model)}</h2>
                <p class="product__code">${line.mpn?escapeHtml(line.mpn):''}</p>
              </div>
              <div class="product__value">${escapeHtml(money.format(Number(line.estimatedValue||0)))}</div>
            </div>
            <div class="product__details">
              <div>
                <span class="label">Condizione dichiarata</span>
                <strong>${escapeHtml(condition)}</strong>
              </div>
              <div>
                <span class="label">Accessori mancanti</span>
                <strong class="${missing.length?'missing':'ok'}">${missingText}</strong>
              </div>
            </div>
            <div class="product__present">
              <span class="label">Accessori dichiarati presenti</span>
              <p>${presentText}</p>
            </div>
          </article>
        `;
      }).join('');

      const customerBlock=(customerName||customerEmail)?`
        <div class="customer">
          <span class="label">Cliente</span>
          <strong>${escapeHtml(customerName||'Cliente FotoEMA')}</strong>
          ${customerEmail?`<small>${escapeHtml(customerEmail)}</small>`:''}
        </div>
      `:'';

      return `<!doctype html>
<html lang="it">
<head>
<meta charset="utf-8">
<meta name="viewport" content="width=device-width,initial-scale=1">
<title></title>
<style>
  @page{size:A4;margin:0}
  *{box-sizing:border-box}
  html,body{margin:0;padding:0;background:#fff;color:#171a18;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Arial,sans-serif}
  body{-webkit-print-color-adjust:exact;print-color-adjust:exact}
  .page{width:210mm;min-height:297mm;margin:0 auto;padding:13mm 15mm 12mm;background:#fff}
  .head{display:flex;align-items:flex-start;justify-content:space-between;gap:22mm;padding-bottom:7mm;border-bottom:1.2mm solid #114c24}
  .brand-logo{display:block;width:43mm;max-width:170px;height:auto;filter:brightness(0) saturate(100%)}
  .brand-sub{margin-top:2.6mm;font-size:8.8px;font-weight:800;letter-spacing:1.1px;text-transform:uppercase;color:#4e5650}
  .quote-id{text-align:right}
  .quote-id span,.label{display:block;font-size:8px;font-weight:800;letter-spacing:.9px;text-transform:uppercase;color:#707771}
  .quote-id strong{display:block;margin-top:2mm;font-size:14px;letter-spacing:.2px}
  .headline{display:flex;align-items:flex-end;justify-content:space-between;gap:10mm;padding:7mm 0 5mm}
  .headline h1{margin:0;font-size:27px;line-height:1.02;letter-spacing:-.8px}
  .headline p{max-width:83mm;margin:1.8mm 0 0;color:#636963;font-size:9.6px;line-height:1.45}
  .status{display:inline-flex;align-items:center;min-height:8mm;padding:0 3.5mm;border-radius:99px;background:#edf5ef;color:#114c24;font-size:8px;font-weight:900;letter-spacing:.6px;text-transform:uppercase;white-space:nowrap}
  .meta{display:grid;grid-template-columns:1fr 1fr 1.35fr;gap:3mm;margin-bottom:5mm}
  .meta>div,.customer{padding:3.2mm 3.6mm;border:1px solid #dfe4e0;border-radius:3mm;background:#fafbfa}
  .meta strong,.customer strong{display:block;margin-top:1.2mm;font-size:10px}
  .customer small{display:block;margin-top:.8mm;color:#626862;font-size:8.5px}
  .customer{margin-bottom:5mm}
  .products{border-top:1px solid #dce1dd}
  .product{padding:4.6mm 0;border-bottom:1px solid #dce1dd;break-inside:avoid}
  .product__top{display:grid;grid-template-columns:7mm 1fr auto;gap:3mm;align-items:start}
  .product__index{display:grid;place-items:center;width:6mm;height:6mm;border-radius:50%;background:#114c24;color:#fff;font-size:8px;font-weight:900}
  .product h2{margin:0;font-size:13px;line-height:1.2}
  .product__code{margin:.8mm 0 0;color:#727873;font-size:8.5px}
  .product__value{padding-left:5mm;font-size:16px;font-weight:900;white-space:nowrap;color:#114c24}
  .product__details{display:grid;grid-template-columns:.8fr 1.2fr;gap:3mm;margin:3.2mm 0 0 10mm}
  .product__details>div{padding:2.7mm 3mm;border-radius:2.5mm;background:#f6f8f6}
  .product__details strong{display:block;margin-top:1mm;font-size:9px;line-height:1.35}
  .product__details .missing{color:#7b342d}
  .product__details .ok{color:#114c24}
  .product__present{margin:2.6mm 0 0 10mm}
  .product__present p{margin:1mm 0 0;color:#555d57;font-size:8.5px;line-height:1.45}
  .summary{display:flex;align-items:center;justify-content:space-between;gap:8mm;margin-top:6mm;padding:5mm 5.5mm;border-radius:4mm;background:#102a19;color:#fff;break-inside:avoid}
  .summary span{display:block;color:#c9d9cd;font-size:8px;font-weight:800;letter-spacing:.8px;text-transform:uppercase}
  .summary small{display:block;margin-top:1mm;color:#dce7df;font-size:8px}
  .summary strong{font-size:28px;line-height:1;letter-spacing:-.7px;white-space:nowrap}
  .notice{margin-top:5mm;padding:4mm 4.5mm;border-left:1.2mm solid #114c24;background:#f4f7f4;break-inside:avoid}
  .notice strong{font-size:9px}
  .notice p{margin:1.3mm 0 0;color:#59615b;font-size:8.2px;line-height:1.5}
  .store{display:grid;grid-template-columns:1fr auto;gap:10mm;align-items:end;margin-top:6mm;padding-top:4mm;border-top:1px solid #d9dedb;color:#616862;font-size:7.8px;line-height:1.5}
  .store strong{display:block;color:#252a26;font-size:8.5px}
  .store__right{text-align:right}
  .print-note{display:none}
  @media screen{
    body{background:#eef1ef;padding:20px}
    .page{box-shadow:0 10px 35px rgba(0,0,0,.12)}
    .print-note{display:flex;justify-content:center;gap:10px;width:210mm;margin:14px auto 0}
    .print-note button{min-height:42px;padding:0 18px;border:0;border-radius:999px;background:#114c24;color:#fff;font:800 12px/1 Arial,sans-serif;cursor:pointer}
  }
  @media print{
    .print-note{display:none!important}
    .page{margin:0}
  }
</style>
</head>
<body>
<main class="page">
  <header class="head">
    <div>
      <img class="brand-logo" src="https://fotoema.it/cdn/shop/files/600x241px-fotoema_447x180.png?v=1731921716" alt="FotoEMA">
      <div class="brand-sub">Fotografia · Video · Imaging</div>
    </div>
    <div class="quote-id">
      <span>Preventivo</span>
      <strong>${escapeHtml(quote.quoteId||'—')}</strong>
    </div>
  </header>

  <section class="headline">
    <div>
      <h1>Valutazione permuta usato</h1>
      <p>Stima preliminare basata sulle condizioni e sugli accessori dichiarati dal cliente.</p>
    </div>
    <div class="status">Da verificare</div>
  </section>

  <section class="meta">
    <div><span class="label">Data</span><strong>${quote.createdAt?escapeHtml(dateFmt.format(new Date(quote.createdAt))):'—'}</strong></div>
    <div><span class="label">Valido fino al</span><strong>${quote.expiresAt?escapeHtml(dateFmt.format(new Date(quote.expiresAt))):'—'}</strong></div>
    <div><span class="label">Numero prodotti</span><strong>${quote.items.length}</strong></div>
  </section>

  ${customerBlock}

  <section class="products">${rows}</section>

  <section class="summary">
    <div>
      <span>Valore indicativo complessivo</span>
      <small>La valutazione definitiva avviene dopo il controllo FotoEMA.</small>
    </div>
    <strong>${escapeHtml(money.format(total()))}</strong>
  </section>

  <section class="notice">
    <strong>Valutazione indicativa e non vincolante.</strong>
    <p>Il valore definitivo viene stabilito da FotoEMA dopo la verifica tecnica ed estetica dei prodotti e degli accessori consegnati. Difetti, anomalie o differenze rispetto alle condizioni dichiarate possono modificare la valutazione finale.</p>
  </section>

  <footer class="store">
    <div>
      <strong>FOTO EMA SRL</strong>
      Via Ferrante Imparato, 190 · 80146 Napoli<br>
      P.IVA / C.F. IT07452751212
    </div>
    <div class="store__right">
      info@fotoema.it<br>
      +39 081 0495450
    </div>
  </footer>
</main>
<div class="print-note">
  <button type="button" onclick="window.print()">Stampa / Salva PDF</button>
</div>
</body>
</html>`;
    };

    const printQuote=()=>{
      if(!quote.items.length){
        showToast('Aggiungi almeno un prodotto');
        return;
      }

      const printWindow=window.open('','_blank','width=960,height=1100');
      if(!printWindow){
        showToast('Consenti l’apertura della finestra di stampa');
        return;
      }

      printWindow.document.open();
      printWindow.document.write(buildPrintDocument());
      printWindow.document.close();
      printWindow.focus();

      const triggerPrint=()=>{
        try{
          printWindow.focus();
          printWindow.print();
        }catch(error){
          showToast('Apri la nuova scheda e premi Stampa / Salva PDF');
        }
      };

      const waitForPrintAssets=async()=>{
        const images=[...printWindow.document.images];
        await Promise.all(images.map(img=>{
          if(img.complete) return Promise.resolve();
          return new Promise(resolve=>{
            img.addEventListener('load',resolve,{once:true});
            img.addEventListener('error',resolve,{once:true});
          });
        }));
        setTimeout(triggerPrint,220);
      };

      if(printWindow.document.readyState==='complete'){
        waitForPrintAssets();
      }else{
        printWindow.addEventListener('load',waitForPrintAssets,{once:true});
      }
    };

    const sendQuoteToMechanic=async()=>{
      if(!quote.items.length){
        showToast('Aggiungi almeno un prodotto');
        return;
      }

      ensureQuoteIdentity();

      if(!customerId){
        window.location.href=accountLoginUrl;
        return;
      }

      if(!saveUrl){
        showToast('Webhook Mechanic non ancora configurato');
        return;
      }

      if(!authTimestamp||!authSignature){
        showToast('Autenticazione cliente non disponibile');
        return;
      }

      const payload={
        version:1,
        quote_id:quote.quoteId,
        customer_id:customerId,
        auth_timestamp:authTimestamp,
        auth_signature:authSignature,
        items:quote.items.map(line=>({
          product_handle:line.productHandle,
          condition:line.condition,
          accessories:(line.accessories||[]).map(item=>({
            label:item.label,
            present:Boolean(item.present)
          }))
        }))
      };

      saveServerButton.disabled=true;
      const previousLabel=saveServerButton.textContent;
      saveServerButton.textContent='Salvataggio...';

      try{
        const response=await fetch(saveUrl,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify(payload)
        });

        if(!response.ok){
          throw new Error('Webhook HTTP '+response.status);
        }

        quote.serverSaveRequestedAt=new Date().toISOString();
        saveQuote();
        saveStatus.hidden=false;
        saveStatus.textContent='Richiesta ricevuta da FotoEMA · '+quote.quoteId+'. I valori vengono ricalcolati lato server prima del salvataggio.';
        saveServerButton.textContent='Aggiorna preventivo salvato';
        showToast('Preventivo inviato a FotoEMA');
      }catch(error){
        saveServerButton.textContent=previousLabel;
        saveStatus.hidden=false;
        saveStatus.textContent='Non è stato possibile inviare il preventivo. Riprova.';
        showToast('Errore nel salvataggio');
      }finally{
        saveServerButton.disabled=false;
      }
    };

    saveServerButton.addEventListener('click',sendQuoteToMechanic);
    printQuoteButton.addEventListener('click',printQuote);

    clearQuote.addEventListener('click',()=>{
      if(window.confirm('Vuoi svuotare completamente la valutazione?')) clearAll();
    });

    renderCart();
  }

  const boot=scope=>scope.querySelectorAll('[data-fe-tradein-multi]').forEach(init);
  boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fe-tradein-test"] && !Shopify.designMode) return;
  try {
    
(() => {
  const conditions = {
    a:{title:'A — Pari al nuovo',text:'Nessun segno evidente di utilizzo. Estetica praticamente perfetta e funzionamento completo.'},
    b:{title:'B — Ottime condizioni',text:'Lievi segni di normale utilizzo, difficilmente visibili. Perfettamente funzionante.'},
    c:{title:'C — Buone condizioni',text:'Normali segni di utilizzo e possibili piccoli segni estetici. Perfettamente funzionante.'},
    d:{title:'D — Usato',text:'Segni di utilizzo evidenti, graffi o usura estetica. Perfettamente funzionante.'},
    e:{title:'E — Molto usato',text:'Usura importante e segni evidenti, ma prodotto ancora perfettamente funzionante.'}
  };
  const money = new Intl.NumberFormat('it-IT',{style:'currency',currency:'EUR',maximumFractionDigits:0});
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().trim();
  const compact = value => normalize(value).replace(/[^a-z0-9]/g,'');
  const parseAccessories = raw => String(raw || '').split(/\r?\n/).map(v=>v.trim()).filter(Boolean).map(line=>{
    const p=line.split('|'); return {label:(p[0]||'').trim(),deduction:Number(p[1]||0)||0};
  });

  function init(root){
    if(root.dataset.ready==='true') return;
    root.dataset.ready='true';
    const dataNode=root.querySelector('[data-products]');
    const search=root.querySelector('[data-search]');
    const results=root.querySelector('[data-results]');
    const selected=root.querySelector('[data-selected]');
    const conditionStep=root.querySelector('[data-condition-step]');
    const accessoryStep=root.querySelector('[data-accessory-step]');
    const conditionWrap=root.querySelector('[data-conditions]');
    const accessoryWrap=root.querySelector('[data-accessories]');
    const quote=root.querySelector('[data-quote]');
    const price=root.querySelector('[data-price]');
    const meta=root.querySelector('[data-quote-meta]');
    let products=[];
    try{products=JSON.parse(dataNode.textContent||'[]').filter(p=>String(p.active)!=='false');}catch(e){}
    let product=null,grade=null,accessoryData=[];

    const hideResults=()=>{results.hidden=true;results.innerHTML='';};
    const find=q=>{
      const n=normalize(q),c=compact(q);
      if(n.length<2) return [];
      return products.filter(p=>{
        const h=[p.brand,p.model,p.mpn,p.aliases].filter(Boolean).join(' ');
        return normalize(h).includes(n) || compact(h).includes(c);
      }).slice(0,8);
    };

    const updateQuote=()=>{
      if(!product || !grade){quote.hidden=true;return;}
      const base=Number(product.prices?.[grade]||0);
      const checks=[...accessoryWrap.querySelectorAll('input[type="checkbox"]')];
      const missing=checks.reduce((sum,el)=>el.checked?sum:sum+Number(accessoryData[Number(el.dataset.index)]?.deduction||0),0);
      price.textContent=money.format(Math.max(0,base-missing));
      meta.textContent=`${product.brand} ${product.model} · ${conditions[grade].title}`;
      quote.hidden=false;
    };

    const renderAccessories=()=>{
      accessoryWrap.innerHTML='';
      accessoryData=parseAccessories(product.accessories);
      accessoryData.forEach((item,i)=>{
        const label=document.createElement('label');
        label.className='fe-tradein-test__accessory is-present';
        const input=document.createElement('input');
        input.type='checkbox'; input.checked=true; input.dataset.index=String(i);
        const span=document.createElement('span'); span.textContent=item.label;
        input.addEventListener('change',()=>{label.classList.toggle('is-present',input.checked);updateQuote();});
        label.append(input,span); accessoryWrap.appendChild(label);
      });
    };

    const renderConditions=()=>{
      conditionWrap.innerHTML='';
      Object.entries(conditions).forEach(([key,info])=>{
        const label=document.createElement('label');
        label.className='fe-tradein-test__condition';
        const input=document.createElement('input');
        input.type='radio'; input.name='fe-condition-' + root.dataset.sectionId; input.value=key;
        const span=document.createElement('span');
        span.innerHTML=`<strong>${info.title}</strong><small>${info.text}</small>`;
        input.addEventListener('change',()=>{
          grade=key;
          [...conditionWrap.children].forEach(x=>x.classList.remove('is-selected'));
          label.classList.add('is-selected');
          updateQuote();
        });
        label.append(input,span); conditionWrap.appendChild(label);
      });
    };

    const choose=p=>{
      product=p;grade=null;
      search.value=`${p.brand} ${p.model}`;
      selected.textContent=`${p.brand} ${p.model}${p.mpn?' · '+p.mpn:''}`;
      selected.hidden=false; hideResults();
      renderConditions();renderAccessories();
      conditionStep.hidden=false;accessoryStep.hidden=false;quote.hidden=true;
      conditionStep.scrollIntoView({behavior:'smooth',block:'nearest'});
    };

    const renderResults=list=>{
      results.innerHTML='';
      if(!list.length){
        const d=document.createElement('div');d.className='fe-tradein-test__empty';d.textContent='Nessun modello trovato nel test.';results.appendChild(d);
      }else{
        list.forEach(p=>{
          const b=document.createElement('button');b.type='button';b.className='fe-tradein-test__result';
          b.innerHTML=`<span><strong>${p.brand} ${p.model}</strong><span>${p.mpn||''}</span></span><b aria-hidden="true">›</b>`;
          b.addEventListener('click',()=>choose(p));results.appendChild(b);
        });
      }
      results.hidden=false;
    };

    search.addEventListener('input',()=>renderResults(find(search.value)));
    search.addEventListener('focus',()=>{if(search.value.trim().length>=2)renderResults(find(search.value));});
    document.addEventListener('click',e=>{if(!root.querySelector('.fe-tradein-test__search-wrap').contains(e.target))hideResults();});
  }

  const boot=scope=>scope.querySelectorAll('[data-fe-tradein]').forEach(root=>{root.dataset.sectionId=root.dataset.sectionId||Date.now().toString(36);init(root);});
  boot(document);
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();

  } catch(e) { console.error(e); }
})();
})();
